export const GOOGLE_ANALYTICS_ACCOUNT = 'G-NSEKRQF5TF';
